export default "__VITE_ASSET__DBGLFvtC__"